export default{
    'MUDAR_DADOS_FILIAL' (state, payload){
        state.filialpadrao = payload
    },
    'MUDAR_USUARIO_LOGADO' (state, payload){
        state.usuario = payload
    },
    'MUDAR_CONFIG_PATHS' (state, payload){
        state.configpaths = payload
    },    
    'MUDAR_PERFIL_USUARIO' (state, payload){
        state.perfilusuario = payload
    },
    'MUDAR_PERFIL_SISTEMA' (state, payload){
        state.perfiltiposis = payload
    },
    'CONSULTA_PRODUTO_CHANGE' (state, payload){
        state.consultaprodutos = payload
    },
    'PRODUTO_RETORNO_CHANGE' (state, payload){
        state.produtoretornoconsulta = payload
    },
    'CONSULTA_CLIENTE_CHANGE' (state, payload){
        state.consultaclientes = payload
    },    
    'CLIENTE_RETORNO_CHANGE' (state, payload){
        state.clienteretornoconsulta = payload
    },
    'CONSULTA_FORNECEDOR_CHANGE' (state, payload){
        state.consultafornecedores = payload
    },    
    'FORNECEDOR_RETORNO_CHANGE' (state, payload){
        state.fornecedorretornoconsulta = payload
    },    
    'CONSULTA_PEDIDO_CHANGE' (state, payload){
        state.consultapedidos = payload
    },
    'PEDIDO_RETORNO_CHANGE' (state, payload){
        state.pedidoretornoconsulta = payload
    },    
    'SIDE_NAV_CHANGE' (state, payload){
        state.sidenav = payload
    },
    'RETORNO_BAIXA_RECEBER_CHANGE' (state, payload){
        state.retornobaixareceber = payload
    },
    'RETORNO_BAIXA_PAGAR_CHANGE' (state, payload){
        state.retornobaixapagar = payload
    },    
    'CONSULTA_TITCOB_CHANGE' (state, payload){
        state.consultatituloscob = payload
    },
    'TITCOB_RETORNO_CHANGE' (state, payload){
        state.tituloscobretornoconsulta = payload
    },
    'ROTINA_TAREFAS_CHANGE' (state, payload){
        state.rotinatarefas = payload
    },
    'ATUALIZAR_ITENSCOLETOR_CHANGE' (state, payload){
        state.atzcoletor = payload
    },
    'VERIFICAR_LIBERACAO_SISTEMA' (state, payload){
        state.verificalib = payload
    },
    'RETORNO_INCLUSAO_PRODUTOS_CHANGE' (state, payload){
        state.listaprodutosretornoconsulta = payload
    },
    'CONSULTA_PEDIDOCOMPRA_CHANGE' (state, payload){
        state.consultapedidoscompra = payload
    },
    'PEDIDOCOMPRA_RETORNO_CHANGE' (state, payload){
        state.pedidocompraretornoconsulta = payload
    },
    'CONSULTA_ESTOQUE_CHANGE' (state, payload){
        state.vizuestoque = payload
    },   
    'RETORNO_CADASTRO_RAPIDO_CLI' (state, payload){
        state.cadastrorapidocliretorno = payload
    },
    'PRODUTO_LISTA_RETORNO_CHANGE' (state, payload){
        state.listaprodutoretorno = payload
    },      
}